<script setup>
    import { useVideoModalControlsStore } from '../stores/VideoModalControls'
    import { storeToRefs } from "pinia";

    const props = defineProps({
        videoUrl: String,
        videoTitle: String,
        videoThumbnail: String
    })
    const videoModalControls = useVideoModalControlsStore(),
          { modalVisible } = storeToRefs(videoModalControls),
          { modalOpen, modalSetTitle } = videoModalControls

    function populateModal(url, title) {
        modalOpen(url)
        modalSetTitle(title)
    }
</script>

<template>
    <div @click="populateModal(props.videoUrl, props.videoTitle)" class="video-embed__thumbnail absolute inset-0 bg-black bg-cover bg-center" :style="`background-image: url('` + props.videoThumbnail + `')`">
        <div v-if="props.videoTitle" class="w-full absolute right-0 bottom-0 left-0 opacity-100 md:opacity-0 transition duration-300">
            <div class="bg-black absolute inset-0 opacity-50"></div>
            <h4 class="text-white text-sm block p-4 m-0 relative z-10">{{ props.videoTitle }}</h4>
        </div>
        <div class="absolute left-1/2 top-1/2 pointer-events-none w-0 h-0 border-l-[25px] border-r-[25px] border-t-[35px] md:border-l-[40px] md:border-r-[40px] md:border-t-[50px] -rotate-90 border-l-transparent border-r-transparent border-t-white transition duration-300 opacity-75 -translate-y-1/2 -translate-x-1/2"></div>
    </div>
</template>
